import { render, staticRenderFns } from "./chaindetail.vue?vue&type=template&id=448bda22&"
import script from "./chaindetail.vue?vue&type=script&lang=js&"
export * from "./chaindetail.vue?vue&type=script&lang=js&"
import style0 from "./chaindetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports